const DELIVERY_COUNTRIES = {
  // CANADA: "Canada",
  USA: { label: "USA", value: "USA" },
};

export default DELIVERY_COUNTRIES;
